module.exports = __webpack_public_path__ + "02ea754b37fd50cca41d6aa1747a3848.png";